"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _invoice = require("@/api/invoice.api");
var _moment = _interopRequireDefault(require("moment"));
var _invoice2 = require("@/types/invoice");
var ApartmentInvoice = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ApartmentInvoice, _Vue);
  var _super = (0, _createSuper2.default)(ApartmentInvoice);
  function ApartmentInvoice() {
    var _this;
    (0, _classCallCheck2.default)(this, ApartmentInvoice);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "apartmentId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "customer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "total", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "query", {
      page: 1,
      limit: 10,
      buildingId: null,
      apartmentId: null,
      customerId: null,
      from: "",
      to: ""
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "date", [(0, _moment.default)().subtract(1, "months").format("YYYY-MM-DD"), (0, _moment.default)().format("YYYY-MM-DD")]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "InvoiceStatusTrans", _invoice2.InvoiceStatusTrans);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "InvoiceTagOptions", _invoice2.InvoiceTagOptions);
    return _this;
  }
  (0, _createClass2.default)(ApartmentInvoice, [{
    key: "handleQuery",
    value: function handleQuery() {
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this$customer, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.loading = true;
                this.query.buildingId = this.buildingId;
                this.query.apartmentId = this.apartmentId;
                this.query.customerId = (_this$customer = this.customer) === null || _this$customer === void 0 ? void 0 : _this$customer.id;
                this.query.from = this.date[0];
                this.query.to = this.date[1];
                _context.next = 9;
                return _invoice.invoiceApi.findAll(this.query);
              case 9:
                res = _context.sent;
                this.data = res.data.invoices;
                this.total = res.data.total;
              case 12:
                _context.prev = 12;
                this.loading = false;
                return _context.finish(12);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0,, 12, 15]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return ApartmentInvoice;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentInvoice.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentInvoice.prototype, "apartmentId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentInvoice.prototype, "customer", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("buildingId", {
  immediate: true
})], ApartmentInvoice.prototype, "handleQuery", null);
ApartmentInvoice = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ApartmentInvoice);
var _default = ApartmentInvoice;
exports.default = _default;